// 严重性
export const seriousnessList = [
    {
        label: "1 没有  (不被注意，不影响性能和使用)",
        value: 1,
    },
    {
        label: "2 标准 (小的缺陷，不影响性能和使用)",
        value: 2,
    },
    {
        label: "3 低的 (小的缺陷，可以在不损失性能的情况下克服)",
        value: 3,
    },
    {
        label: "4 低的 (部分功能异常，可以在不损失性能的情况下克服)",
        value: 4,
    },
    {
        label: "5 适度的 (部分功能异常，不影响使用，可以远程解决)",
        value: 5,
    },
    {
        label: "6 严重 (部分功能异常，影响使用，可以远程解决)",
        value: 6,
    },
    {
        label: "7 严重 (功能异常，影响使用，需要现场维修)",
        value: 7,
    },
    {
        label: "8 非常严重 (功能异常，影响使用，导致客户不满，引起退货换货)",
        value: 8,
    },
    {
        label: "9 警告 (违法：不符合法律法规)",
        value: 9,
    },
    {
        label: "10 危险 (伤害客户或员工：漏电、割伤划伤)",
        value: 10,
    },
];

// 严重性
export const frequencyList = [
    {
        label: "1 几乎没有 (故障相对较少，5~10年1次)",
        value: 1,
    },
    {
        label: "2 非常小 (故障相对较少，3~5年1次)",
        value: 2,
    },
    {
        label: "3 少数的 (故障相对较少，1~3年1次)",
        value: 3,
    },
    {
        label: "4 非常低 (偶发故障，每年1次或更多)",
        value: 4,
    },
    {
        label: "5 低的 (偶尔故障，每6个月1次或更多)",
        value: 5,
    },
    {
        label: "6 适度的 (重复故障，每3个月1次或更多)",
        value: 6,
    },
    {
        label: "7 高 (重复故障，每月都发生)",
        value: 7,
    },
    {
        label: "8 高 (重复故障，每两周都发生)",
        value: 8,
    },
    {
        label: "9 非常高 (失败几乎是不可避免的，每周都发生)",
        value: 9,
    },
    {
        label: "10 非常高 (失败几乎是不可避免的，每天都发生)",
        value: 10,
    },
];

// 复现
export const recurrentList = [
    {
        label: "1 无法确定 (过程控制很难检测到的故障，连续7天老化没法复现)",
        value: 1,
    },
    {
        label: "2 非常低 (过程控制很难检测到的故障，连续7天老化复现1~2次)",
        value: 2,
    },
    {
        label: "3 非常低 (过程控制很难检测到的故障，连续72小时老化复现1~2次)",
        value: 3,
    },
    {
        label: "4 低 (过程控制很难检测到的故障，连续24小时老化复现1~2次)",
        value: 4,
    },
    {
        label: "5 低 (过程控制很难检测到的故障，连续12小时老化复现1~2次)",
        value: 5,
    },
    {
        label: "6 适度的 (过程控制可以检测到的故障，可以10%复现)",
        value: 6,
    },
    {
        label: "7 适度的 (过程控制可以检测到的故障，可以20%复现)",
        value: 7,
    },
    {
        label: "8 高 (过程控制可以检测到的故障，可以30%复现)",
        value: 8,
    },
    {
        label: "9 非常高 (过程控制可以检测到的故障，可以50%复现)",
        value: 9,
    },
    {
        label: "10 可以肯定 (过程控制很容易检测到的故障，可以100%复现)",
        value: 10,
    },
];

export const processesList = [
    {
        label: "来料检验",
        value: "来料检验",
    },
    {
        label: "三大件",
        value: "三大件",
    },
    {
        label: "束腰",
        value: "束腰",
    },
    {
        label: "参考臂",
        value: "参考臂",
    },
    {
        label: "绕光纤参考臂",
        value: "绕光纤参考臂",
    },
    {
        label: "探测器",
        value: "探测器",
    },
    {
        label: "完整参考臂",
        value: "完整参考臂",
    },
    {
        label: "定标",
        value: "定标",
    },
    {
        label: "总装调试",
        value: "总装调试",
    },
    {
        label: "成品",
        value: "成品",
    },
];
